module.exports = __webpack_public_path__ + "static/media/loading-animation-delivery.38cc15d7.gif";